import { Store } from 'game/store/gameStore';
import { getScreenSize, setScreenSize } from './screen';
import { SoundManager } from './soundManager';
import { GameEvent } from 'game/events/gameEvent';
import { EventName } from 'game/events/eventsName';

export function initDisplay() {
    onDocumentVisible();
    document.addEventListener('visibilitychange', onDocumentVisible);
    window.onresize = resizeView;
    resizeView();
    document.addEventListener('pointerdown', firstInteraction);
}

const resizeFunction = {} as { [key: string]: (width: number, height: number) => void };
const earlyResizeFunction = {} as { [key: string]: (width: number, height: number) => void };
const lateResizeFunction = {} as { [key: string]: (width: number, height: number) => void };

export function resizeEvent(callback: (width: number, height: number) => void) {
    setTimeout(
        (callback) => {
            const { width, height } = getScreenSize();
            callback(width, height);
        },
        10,
        callback
    );
}

export function addResizeListener(callback: (width: number, height: number) => void, key: string, hideWarning = false) {
    if (!resizeFunction[key]) {
        resizeEvent(callback);
    } else if (!hideWarning) {
        console.error('resize function overwritten', key);
    }
    resizeFunction[key] = callback;
}

export function addEarlyResizeListener(
    callback: (width: number, height: number) => void,
    key: string,
    hideWarning = false
) {
    if (!earlyResizeFunction[key]) {
        resizeEvent(callback);
    } else if (!hideWarning) {
        console.error('resize function overwritten', key);
    }
    earlyResizeFunction[key] = callback;
}

export function addLateResizeListener(
    callback: (width: number, height: number) => void,
    key: string,
    hideWarning = false
) {
    if (!lateResizeFunction[key]) {
        resizeEvent(callback);
    } else if (!hideWarning) {
        console.error('resize function overwritten', key);
    }
    lateResizeFunction[key] = callback;
}

export function removeResizeListener(key: string) {
    if (Object.keys(earlyResizeFunction).includes(key)) {
        delete earlyResizeFunction[key];
    }
    if (Object.keys(resizeFunction).includes(key)) {
        delete resizeFunction[key];
    }
    if (Object.keys(lateResizeFunction).includes(key)) {
        delete lateResizeFunction[key];
    }
}

function resizeView() {
    resizeGame();
}
function refreshScreenSize() {
    const gameContainer = document.getElementById('solitaire-container');
    if (gameContainer) return { width: gameContainer.clientWidth, height: gameContainer.clientHeight };

    return { width: window.innerWidth, height: window.innerHeight };
}

const resizeGame = () => {
    const gameContainer = document.getElementById('solitaire-container');
    if (!gameContainer) return;
    let w = gameContainer.clientWidth;
    let h = gameContainer.clientHeight;
    try {
        const { width, height } = refreshScreenSize();
        w = width;
        h = height;
    } catch (error) {}
    if (w * h === 0) {
        resizeView();
    } else {
        setScreenSize(w, h);
        Object.keys(earlyResizeFunction).forEach((fnKey) => {
            if (earlyResizeFunction[fnKey]) earlyResizeFunction[fnKey](w, h);
            else delete earlyResizeFunction[fnKey];
        });

        Object.keys(resizeFunction).forEach((fnKey) => {
            if (resizeFunction[fnKey]) resizeFunction[fnKey](w, h);
            else delete resizeFunction[fnKey];
        });
        Object.keys(lateResizeFunction).forEach((fnKey) => {
            if (lateResizeFunction[fnKey]) lateResizeFunction[fnKey](w, h);
            else delete lateResizeFunction[fnKey];
        });
    }
};

export function isAndroid() {
    return window.navigator.userAgent.toLowerCase().includes('android');
}
export function isIOS() {
    const platform = window.navigator?.userAgent || window.navigator.platform;
    const ios = /iphone|ipod|ipad/.test(platform.toLocaleLowerCase());
    return ios;
}
export function getOS() {
    if (isAndroid()) {
        return 'android';
    }
    if (isIOS()) {
        return 'ios';
    }
    return navigator.userAgent.indexOf('Mac OS X') ? 'desktop_mac' : 'desktop_windows';
}
function onDocumentVisible() {
    GameEvent.emit(EventName.ON_VISIBILITY_CHANGE, document.visibilityState === 'visible');
    if (document.visibilityState === 'visible') {
        SoundManager.mute(!Store.soundOn);
        resizeGame();
    } else {
        SoundManager.mute(true);
    }
}

let gameTouched = false;

export function hasFirstInteraction() {
    return gameTouched;
}
export function firstInteraction() {
    if (!gameTouched) {
        document.removeEventListener('pointerdown', firstInteraction);
        gameTouched = true;
    }
}
